module.exports = __webpack_public_path__ + "static/media/resume_preview.cf8b2285.jpg";